import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPages.css';

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <Navbar cartItemCount={0} />
      
      <div className="legal-content">
        <div className="legal-container">
          <h1>Términos y Condiciones</h1>
          <p className="last-updated">Última actualización: {new Date().toLocaleDateString('es-AR')}</p>

          <section className="legal-section">
            <h2>1. Aceptación de Términos</h2>
            <p>
              Al acceder y utilizar el sitio web de Sol y Luna Kiosko, usted acepta estar vinculado por estos Términos y Condiciones. 
              Si no está de acuerdo con alguna parte de estos términos, le solicitamos que no utilice nuestro sitio.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Uso de la Licencia</h2>
            <p>
              Se le otorga permiso temporal para ver y utilizar nuestro sitio únicamente para uso personal y no comercial. 
              Esta es una licencia, no una transferencia de propiedad, y bajo esta licencia no puede:
            </p>
            <ul>
              <li>Modificar o copiar el material</li>
              <li>Usar el material para cualquier propósito comercial o para cualquier empresa pública</li>
              <li>Intentar descompilar o hacer ingeniería inversa de cualquier software contenido en nuestro sitio</li>
              <li>Remover cualquier aviso de derechos de autor u otros avisos de propiedad del material</li>
              <li>Transferir el material a otra persona o "reflejar" el material en cualquier otro servidor</li>
              <li>Usar el sitio de manera que interfiera con el uso normal del sitio por parte de otros usuarios</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Descargo de Responsabilidad</h2>
            <p>
              El material en el sitio web de Sol y Luna Kiosko se proporciona "tal cual". 
              No hacemos garantías, expresas o implícitas, y por este medio renunciamos y descartamos cualquier otra garantía, 
              incluidas pero no limitada a garantías implícitas o condiciones de comerciabilidad, adecuación para un propósito particular, 
              o incumplimiento de no infracción.
            </p>
            <p>
              Además, Sol y Luna Kiosko no garantiza ni declara que:
            </p>
            <ul>
              <li>El material en su sitio es preciso, completo o actual</li>
              <li>El sitio estará disponible sin interrupción o que estará libre de errores</li>
              <li>Los defectos serán corregidos</li>
              <li>El sitio o el servidor que lo pone a disposición están libres de virus u otros componentes dañinos</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Limitación de Responsabilidad</h2>
            <p>
              En ningún caso, Sol y Luna Kiosko o sus proveedores serán responsables por daños (incluidos daños por pérdida de datos, 
              pérdida de ganancias, interrupción del servicio o cualquier otro daño consiguiente o incidental) que surja del uso 
              o la incapacidad de usar los materiales, incluso si Sol y Luna Kiosko o un representante autorizado de Sol y Luna Kiosko 
              ha sido notificado oralmente o por escrito de la posibilidad de tal daño.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Precisión del Material</h2>
            <p>
              El material que aparece en el sitio web de Sol y Luna Kiosko podría incluir errores técnicos, tipográficos o fotográficos. 
              Sol y Luna Kiosko no garantiza que ninguno del material en su sitio web sea preciso, completo o actual. 
              Sol y Luna Kiosko puede hacer cambios en el material en su sitio web en cualquier momento sin previo aviso.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Materiales de Referencias</h2>
            <p>
              Sol y Luna Kiosko no ha revisado todos los sitios vinculados con su sitio web y no es responsable del contenido 
              de ningún sitio vinculado. La inclusión de cualquier enlace no implica endoso por parte de Sol y Luna Kiosko del sitio. 
              El uso de cualquier sitio web vinculado es bajo el riesgo del usuario.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Modificaciones</h2>
            <p>
              Sol y Luna Kiosko puede revisar estos términos y condiciones para su sitio web en cualquier momento sin previo aviso. 
              Al usar este sitio web, usted acepta estar vinculado por la versión actual de estos términos y condiciones.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Ley de Gobierno</h2>
            <p>
              Estos términos y condiciones y cualquier litigio separado, acción o procedimiento que surja en conexión con ellos 
              será regido por las leyes de Argentina, y usted irrevocablemente consiente la jurisdicción exclusiva de los 
              tribunales ubicados en Argentina.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Pedidos y Aceptación</h2>
            <h3>9.1 Colocación de Pedidos</h3>
            <p>
              Al colocar un pedido, usted proporciona una oferta para comprar un producto bajo estos términos y condiciones. 
              Todos los pedidos están sujetos a aceptación y confirmación por parte de Sol y Luna Kiosko.
            </p>

            <h3>9.2 Confirmación de Pedidos</h3>
            <p>
              La confirmación de su pedido se enviará por correo electrónico. Esta confirmación no significa que su pedido haya sido aceptado. 
              Nos reservamos el derecho de rechazar cualquier pedido por cualquier razón, incluyendo pero no limitado a:
            </p>
            <ul>
              <li>Disponibilidad de productos</li>
              <li>Errores en los precios o descripciones de productos</li>
              <li>Sospecha de fraude</li>
            </ul>

            <h3>9.3 Precios</h3>
            <p>
              Nos reservamos el derecho de cambiar los precios en cualquier momento. 
              Los precios mostrados en nuestro sitio son válidos solo en el momento de la compra y no constituyen una oferta.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Envíos</h2>
            <h3>10.1 Métodos de Envío</h3>
            <p>
              Ofrecemos varios métodos de envío. Los tiempos de entrega son estimados y no garantizados. 
              Los tiempos de tránsito comienzan después de que se procesa el pago.
            </p>

            <h3>10.2 Riesgo de Transporte</h3>
            <p>
              Todos los productos se envían bajo riesgo del comprador. Recomendamos obtener un seguro de envío para artículos valiosos. 
              Los daños durante el tránsito deben reportarse dentro de 48 horas de recibir el paquete.
            </p>

            <h3>10.3 Retiros en Tienda</h3>
            <p>
              Los productos pueden retirarse en nuestras sucursales: Chacabuco y Lavalle, 9 de Julio y Saavedra, o Almafuerte y Quintana. 
              El retiro debe realizarse dentro de 10 días después del pedido.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Pagos</h2>
            <h3>11.1 Métodos de Pago Aceptados</h3>
            <p>
              Aceptamos las siguientes formas de pago: Tarjeta de Crédito (Visa, Mastercard), 
              Débito Bancario y Mercado Pago.
            </p>

            <h3>11.2 Seguridad de Pagos</h3>
            <p>
              Todos los pagos se procesan a través de proveedores de pagos seguros. 
              Su información de pago está encriptada y protegida de acuerdo con los estándares de la industria.
            </p>

            <h3>11.3 Reembolsos</h3>
            <p>
              Los reembolsos se procesarán dentro de 5 a 7 días hábiles después de confirmar la devolución. 
              El tiempo de acreditación puede variar según su institución financiera.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Disputas y Reclamaciones</h2>
            <p>
              Si tiene una reclamación sobre sus productos o servicios, comuníquese con nosotros primero. 
              Haremos todo lo posible para resolver el problema dentro de 5 días hábiles.
            </p>
            <p>
              Para reclamaciones relacionadas con pagos, puede contactar a su instituciónfinanciera o a Mercado Pago.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Datos Personales y Cuentas</h2>
            <p>
              Si abre una cuenta en nuestro sitio, es responsable de mantener la confidencialidad de su contraseña 
              y es responsable de toda la actividad que ocurra bajo su cuenta. Usted acepta notificarnos inmediatamente 
              de cualquier uso no autorizado de su cuenta.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Servicio al Cliente</h2>
            <p>
              Nuestro equipo de servicio al cliente está disponible para responder preguntas, comentarios y reclamaciones. 
              Nos esforzamos por responder dentro de 24 horas.
            </p>
            <div className="contact-info">
              <p><strong>Sol y Luna Kiosko</strong></p>
              <p>Email: soporte@solylunakiosko.com</p>
              <p>WhatsApp: +54 (código) XXXXXXX</p>
              <p>Teléfono: +54 (código) XXXXXXX</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>15. Cambios en Términos</h2>
            <p>
              Nos reservamos el derecho de actualizar estos Términos y Condiciones en cualquier momento. 
              Se le notificará sobre cambios significativos mediante correo electrónico o un aviso prominente en el sitio.
            </p>
          </section>

          <section className="legal-section">
            <h2>16. Contacto</h2>
            <p>
              Si tiene preguntas sobre estos Términos y Condiciones, contáctenos en:
            </p>
            <div className="contact-info">
              <p><strong>Sol y Luna Kiosko</strong></p>
              <p>Email: legal@solylunakiosko.com</p>
              <p>Dirección: Chacabuco y Lavalle, Argentina</p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
